import type { KnownTrackingLabels } from '@shared/tracking/TrackingLabels';

export function getPageViewTracking(historic: boolean, experimentIds: string[] = [], pageCluster?: string) {
    const pageViewTracking: Partial<KnownTrackingLabels> = {
        san_ListEventType: 'tilelistview',
        ot_PageCluster: pageCluster || 'UNKNOWN',
    };

    if (historic) pageViewTracking.san_Interaction = 'browser_navigation';

    if (experimentIds.length) {
        pageViewTracking['wk.san_ReptileExperimentSegment'] = experimentIds;
    }

    return pageViewTracking;
}
